import { differenceInCalendarDays, endOfDay, parseISO } from "date-fns";

import { GqlPlannerV2VisitPossibleDaysStatus } from "~/__generated__/graphql/types";

import { VisitStatusTimelineFragment } from "./fragment.generated";

const PLANNER_VISIT_POSSIBLE_DAYS_AT_RISK_OFFSET = 10;
const PLANNABLE_SOON_DAYS_RANGE = 7;

// todo: monorepo: duplicate of BE function
export function calculatePlannerVisitPossibleDaysStatus(input: VisitStatusTimelineFragment["possibleDays"], on: Date) {
    const ranges = input.map(possibleDays => ({
        start: parseISO(possibleDays.start),
        end: endOfDay(parseISO(possibleDays.end)),
    }));

    if (ranges.length < 1) {
        return GqlPlannerV2VisitPossibleDaysStatus.Impossible;
    }

    // check if the date is within any valid range
    const isWithinAnyRange = ranges.some(range => range.start <= on && range.end >= on);

    if (!isWithinAnyRange) {
        // a range starts within PLANNABLE_SOON_DAYS_RANGE calendar days
        const hasRangeStartingSoon = ranges.some(range => {
            const diffDays = differenceInCalendarDays(range.start, on);

            return diffDays > 0 && diffDays <= PLANNABLE_SOON_DAYS_RANGE;
        });

        if (hasRangeStartingSoon) {
            return GqlPlannerV2VisitPossibleDaysStatus.PlannableSoon;
        }

        // if not within any range, check if there are future ranges
        const hasRangesInFuture = ranges.some(range => range.start > on);
        return hasRangesInFuture
            ? GqlPlannerV2VisitPossibleDaysStatus.NotYetPlannable
            : GqlPlannerV2VisitPossibleDaysStatus.OutOfProtocol;
    }

    // find the specific range that contains the current date
    const currentRange = ranges.find(range => range.start <= on && range.end >= on);

    // check if the specific range containing the current date is at risk
    if (currentRange) {
        const difference = differenceInCalendarDays(currentRange.end, on);
        const isCurrentRangeAtRisk = difference < PLANNER_VISIT_POSSIBLE_DAYS_AT_RISK_OFFSET;

        return isCurrentRangeAtRisk
            ? GqlPlannerV2VisitPossibleDaysStatus.PlannableAtRisk
            : GqlPlannerV2VisitPossibleDaysStatus.PlannableOk;
    }

    // fallback (should not reach here due to earlier checks)
    return GqlPlannerV2VisitPossibleDaysStatus.Impossible;
}
